import $ from 'jquery';

// for tab panel specifically
$('.tab-panel ul.dropdown-menu button').on('click', function(e){
  let buttonValue = e.target.innerHTML;
  $('.tab-panel ul.nav a.dropdown-toggle').text(buttonValue);
  $('.tab-panel ul.nav a.dropdown-toggle').removeClass('active');
});

$('.nav button').on('click', function(e){
  $(e.currentTarget).parent().siblings().children().removeClass('active');
});